export default {
    name: "SetVariable",
    title: "Set Variable",
    icon: "mdi-variable",
    create() {
        return {
            name: this.title,
            description: "",
            actionType: this.name,
            parameter1: null,
            parameter2: null,
            parameter3: null,
            parameter4: null,
            parameter5: null,
            filters: [],
            values: [],
            columns: [],
        };
    },
};